import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import deleteaction from "../../context/action/return_item_company/deleteaction";
import updateaction from "../../context/action/return_item_company/updateaction";
import getitemaction from "../../context/action/return_item_company/getitemaction";
import { MdDeleteForever } from "react-icons/md";
import numberbeautify from "../../utils/numberbeautify";

const Return_item_companyeditmodal = (props) => {
  const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);

  const [barcode, setbarcode] = useState();

  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  const [error2, seterror2] = useState(false);
  const [error3, seterror3] = useState(false);
  return (
    <>
      {props.show ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none p-4">
            <div className="relative w-full my-2 sm:my-4 md:my-6 mx-auto md:w-11/12 lg:w-5/6">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/* Header */}
                <div className="flex items-center justify-between p-3 sm:p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl sm:text-2xl md:text-3xl uppercase font-semibold flex-1">
                    گۆڕانکاری
                  </h3>
                  <button
                    className="p-1 ml-auto text-black opacity-80 text-2xl sm:text-3xl leading-none font-semibold"
                    onClick={() => props.setshow(false)}
                  >
                    <span className="block">X</span>
                  </button>
                </div>

                {/* Body */}
                <div className="relative p-4 sm:p-6 h-[60vh] sm:h-[70vh] overflow-y-auto">
                  {/* Form Fields Container */}
                  <div className="flex flex-col sm:flex-row flex-wrap gap-4 sm:gap-6">
                    {/* Company Select */}
                    <div className="w-full sm:w-1/3">
                      <label
                        className={`block text-sm font-medium mb-2 
                        ${error ? "text-red-700" : "text-gray-700"}`}
                      >
                        کۆمپانیای دابینکەر
                      </label>
                      <select
                        className={`w-full bg-gray-50 border rounded py-2.5 px-4 
                          ${error ? "border-red-300" : "border-gray-300"}
                          focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                        value={props?.company_id}
                        onChange={(val) => {
                          props?.setcompany_id(val.target.value);
                          seterror(false);
                        }}
                      >
                        <option value="">کۆمپانیا</option>
                        {initState.company.map((lis) => (
                          <option key={lis.company_id} value={lis.company_id}>
                            {lis.company_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Date Input */}
                    <div className="w-full sm:w-1/3">
                      <label
                        className={`block text-sm font-medium mb-2
                        ${error1 ? "text-red-700" : "text-gray-700"}`}
                      >
                        بەروار
                      </label>
                      <input
                        type="date"
                        className={`w-full bg-gray-50 border rounded py-2.5 px-4
                          ${error1 ? "border-red-300" : "border-gray-300"}
                          focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                        value={props?.company_return_date}
                        onChange={(val) =>
                          props?.setcompany_return_date(val.target.value)
                        }
                        onFocus={() => seterror1(false)}
                      />
                    </div>

                    {/* Note Input */}
                    <div className="w-full sm:w-1/3">
                      <label className="block text-sm font-medium mb-2 text-gray-700">
                        تێبینی
                      </label>
                      <input
                        type="text"
                        className="w-full bg-gray-50 border border-gray-300 rounded py-2.5 px-4
                          focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        value={props?.company_return_note}
                        onChange={(val) =>
                          props?.setcompany_return_note(val.target.value)
                        }
                      />
                    </div>
                  </div>

                  {/* Barcode Scanner */}
                  <div className="w-full mt-6">
                    <div className="bg-gray-400 rounded-lg p-4">
                      <label className="block text-sm font-medium mb-2 text-white">
                        باڕکۆد
                      </label>
                      <input
                        type="text"
                        className="w-full bg-white border border-gray-200 rounded py-2.5 px-4
                          focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        value={barcode}
                        onChange={(val) => setbarcode(val.target.value)}
                        autoFocus
                        onKeyDown={(key) => {
                          if (key.key === "Enter") {
                            getitemaction(barcode)(recaller)(setrecaller)(
                              props?.items
                            )(props?.setitems)(setbarcode);
                          }
                        }}
                      />
                    </div>
                  </div>

                  {/* Items Table */}
                  {props?.items.length > 0 && (
                    <div className="mt-8 -mx-4 sm:mx-0 overflow-hidden">
                      <div className="overflow-x-auto shadow-md rounded-lg">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead>
                            <tr>
                              <th className="px-3 sm:px-5 py-3 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase">
                                ناوی کاڵا
                              </th>
                              <th className="px-3 sm:px-5 py-3 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase">
                                باڕکۆد
                              </th>
                              <th className="px-3 sm:px-5 py-3 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase">
                                نرخ
                              </th>
                              <th className="px-3 sm:px-5 py-3 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase">
                                عەدەد
                              </th>
                              <th className="px-3 sm:px-5 py-3 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase">
                                کۆی نرخ
                              </th>
                              <th className="px-3 sm:px-5 py-3 bg-gray-100 text-center text-xs font-semibold text-gray-700 uppercase">
                                ڕەشکردنەوە
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {props?.items.map((lis, index) => (
                              <tr key={index}>
                                <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                  <p className="text-gray-900 whitespace-no-wrap">
                                    {lis.item_name}
                                  </p>
                                </td>
                                <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                  <p className="text-gray-900 whitespace-no-wrap">
                                    {lis.item_barcode}
                                  </p>
                                </td>
                                <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                  <input
                                    className={
                                      "appearance-none block w-[120px] md:w-full bg-white text-black border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                    }
                                    id="grid-last-name"
                                    type="number"
                                    value={lis.item_price}
                                    onClick={(val) => {
                                      val.target.select();
                                    }}
                                    onChange={(val) => {
                                      props?.setitems(
                                        props?.items.map((lis, indexx) =>
                                          index == indexx
                                            ? {
                                                item_id: lis.item_id,
                                                service_id: lis.service_id,
                                                item_name: lis.item_name,
                                                item_barcode: lis.item_barcode,
                                                item_price: val.target.value,
                                                item_qty: lis.item_qty,
                                              }
                                            : lis
                                        )
                                      );
                                      // setstopsell(false);
                                    }}
                                  />
                                </td>
                                <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                  <input
                                    className={
                                      "appearance-none block w-[120px] md:w-full bg-white text-black border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                    }
                                    id="grid-last-name"
                                    type="number"
                                    value={lis.item_qty}
                                    onClick={(val) => {
                                      val.target.select();
                                    }}
                                    onChange={(val) => {
                                      props?.setitems(
                                        props?.items.map((lis, indexx) =>
                                          index == indexx
                                            ? {
                                                item_id: lis.item_id,
                                                service_id: lis.service_id,
                                                item_name: lis.item_name,
                                                item_barcode: lis.item_barcode,
                                                item_price: lis.item_price,
                                                item_qty: val.target.value,
                                              }
                                            : lis
                                        )
                                      );
                                    }}
                                  />
                                </td>
                                <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                  {numberbeautify(
                                    Number(lis.item_qty) * Number(lis.item_price)
                                  )}
                                </td>
                                <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                  <p className="text-gray-900 whitespace-no-wrap">
                                    <MdDeleteForever
                                      size={28}
                                      color="#e74c3c"
                                      className="cursor-pointer"
                                      onClick={() => {
                                        props?.setitems(
                                          props?.items.filter(
                                            (list) => list.item_id != lis.item_id
                                          )
                                        );
                                      }}
                                    />
                                  </p>
                                </td>
                              </tr>
                            ))}
                            <tr>
                              <th
                                className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                colSpan={3}
                              >
                                کۆی گشتی
                              </th>
                              <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center">
                                {numberbeautify(
                                  props?.items.reduce(
                                    (a, v) =>
                                      (a =
                                        Number(a) +
                                        Number(v.item_price) * Number(v.item_qty)),
                                    0
                                  )
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>

                {/* Footer */}
                <div className="flex flex-col sm:flex-row items-center justify-end gap-2 p-4 sm:p-6 border-t border-solid border-slate-200">
                  <button
                    className="w-full sm:w-auto bg-red-500 text-white px-4 sm:px-6 py-2 sm:py-3 rounded
                      hover:bg-red-600 transition-colors duration-150"
                    onClick={() => {
                      if (window.confirm("ئاگاداری ڕەشکردنەوە . دڵنیای ؟")) {
                        deleteaction(props.company_return_id)(recaller)(setrecaller)(
                          initDispatch
                        )(clear);
                      }
                    }}
                  >
                    ڕەشکردنەوە
                  </button>
                  <button
                    className="w-full sm:w-auto bg-green-500 text-white px-4 sm:px-6 py-2 sm:py-3 rounded
                      hover:bg-green-600 transition-colors duration-150"
                    onClick={() => {
                      if (window.confirm("ئاگاداری گۆڕانکاری . دڵنیای ؟")) {
                        updateaction(
                          props.company_return_id,
                          props?.company_return_date,
                          props?.company_id,
                          props?.company_return_note,
                          props?.items
                        )(recaller)(setrecaller)(initDispatch)(clear);
                      }
                    }}
                  >
                    گۆڕانکاری
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default Return_item_companyeditmodal;